function normalizeDomain(input) {
  if (!input) return null;
  const trimmed = String(input).trim();
  return trimmed ? trimmed.replace(/^https?:\/\//i, "").replace(/\/$/, "") : null;
}

export function getTenantSubdomain(slug) {
  if (!slug) return null;
  const parts = String(slug).split("-");
  if (parts.length > 1 && /^\d+$/.test(parts.at(-1))) parts.pop();
  return parts.join("-") || null;
}

export function getTenantWorkspaceUrl(slug, location = typeof window !== "undefined" ? window.location : null) {
  const subdomain = getTenantSubdomain(slug);
  if (!subdomain || !location) return null;
  const rootDomain = normalizeDomain(import.meta.env.VITE_TENANT_ROOT_DOMAIN);
  if (rootDomain) return `https://${subdomain}.${rootDomain}/`;
  if (location.hostname === "localhost") return `http://${subdomain}.localhost:${location.port || 5173}/`;
  if (location.hostname === "portal.cbcfx.site" || location.hostname.endsWith(".cbcfx.site")) return `${location.protocol}//${subdomain}.cbcfx.site/`;
  return null;
}
